import { DirectiveOptions } from 'vue';

import anchor from './anchor';
import clickOutside from './clickOutside';
import dataForDatalayer from './dataForDatalayer';
import dateFormat from './dateFormat';
import gaClick from './gaClick';
import hidden from './hidden';
import hideIfBigger from './hideIfBigger';
import keepRatio from './keepRatio';
import minExtensionPrice from './minExtensionPrice';
import minExtensionSSPrice from './minExtensionSSPrice';
import minTourPrice from './minTourPrice';
import minTourSSPrice from './minTourSSPrice';
import popup from './popup';
import preloader from './preloader';
import { print, printHeadless, save, saveHeadless } from './printPage';
import questionnaire from './questionnaire';
import salesScore from './salesScore';
import scroll from './scroll';
import scrollableTabs from './scrollableTabs';
import share from './share';
import { swipedContent, swipedVideos } from './swipedContent';
import tableWrap from './tableWrap';
import watchOrientation from './watchOrientation';

const directives: { [key: string]: DirectiveOptions } = {
    'click-outside': clickOutside,
    'hidden': hidden,
    'min-tour-price': minTourPrice,
    'min-tour-ss-price': minTourSSPrice,
    'min-extension-price': minExtensionPrice,
    'min-extension-ss-price': minExtensionSSPrice,
    'popup': popup,
    'preloader': preloader,
    'scroll': scroll,
    'anchor': anchor,
    'salesScore': salesScore,
    'save': save,
    'save-headless': saveHeadless,
    'print': print,
    'print-headless': printHeadless,
    'share': share,
    'keep-ratio': keepRatio,
    'watch-orientation': watchOrientation,
    'date-format': dateFormat,
    'table-wrap': tableWrap,
    'hide-if-bigger': hideIfBigger,
    'questionnaire': questionnaire,
    'gaClick': gaClick,
    'swiped-content': swipedContent,
    'swiped-videos': swipedVideos,
    'data-for-datalayer': dataForDatalayer,
    'scrollable-tabs': scrollableTabs,
};

export default directives;



// WEBPACK FOOTER //
// ./src/directives/index.ts